var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoKbb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 55,
    viewBox: "0 0 41 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11282_83982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 34.4687V0H31.3225V34.4687",
    fill: "url(#paint0_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66016 28.7988V55.0004L20.5009 46.7534L31.3372 55.0004V28.7988H9.66016Z",
    fill: "url(#paint1_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 54.0238V28.793H29.0137L29.0204 53.2387",
    fill: "url(#paint2_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9679 53.2529V19.207H10.9319L10.9297 54.047",
    fill: "url(#paint3_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 26.2016V0H31.3225V26.2016",
    fill: "url(#paint4_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0477 34.8869V0H29.0117V34.8869",
    fill: "url(#paint5_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint6_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 26.2016V0H31.3225V26.2016",
    fill: "url(#paint7_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0477 34.8869V0H29.0117V34.8869",
    fill: "url(#paint8_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint9_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 26.2016V0H31.3225V26.2016",
    fill: "url(#paint10_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0477 34.8869V0H29.0117V34.8869",
    fill: "url(#paint11_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint12_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 26.2016V0H31.3225V26.2016",
    fill: "url(#paint13_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 34.8869V0H29.0137V34.8869",
    fill: "url(#paint14_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint15_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 26.2016V0H31.3225V26.2016",
    fill: "url(#paint16_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 34.8869V0H29.0137V34.8869",
    fill: "url(#paint17_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint18_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 26.2016V0H31.3225V26.2016",
    fill: "url(#paint19_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 34.8869V0H29.0137V34.8869",
    fill: "url(#paint20_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint21_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3247 0H9.66797V32.8045H31.3247V0Z",
    fill: "url(#paint22_radial_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 34.8869V0H29.0137V34.8869",
    fill: "url(#paint23_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint24_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 34.8869V0H29.0137V34.8869",
    fill: "url(#paint25_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696 34.8869V0H10.9336V34.8869",
    fill: "url(#paint26_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9916 39.3846L31.8204 38.6934L31.8836 41.9099L28.911 40.6193L28.34 43.7865L25.6766 41.9457L24.4939 44.9429L22.2459 42.6234L20.4944 45.3321L18.7451 42.6212L16.4948 44.9385L15.3143 41.9434L12.651 43.7821L12.0799 40.6148L9.10509 41.9032L9.1728 38.6867L5.99934 39.3756L6.69678 36.2352L3.45334 36.2978L4.75343 33.352L1.55965 32.7839L3.41497 30.1467L0.392733 28.9746L2.73333 26.7446L0 25.0111L2.73559 23.2776L0.39499 21.0475L3.41723 19.8754L1.5619 17.236L4.75794 16.6724L3.45786 13.7243L6.70355 13.7892L6.00837 10.6465L9.17732 11.3377L9.11412 8.1212L12.089 9.40958L12.6577 6.24454L15.3211 8.08541L16.5061 5.08813L18.7541 7.4099L20.5056 4.70117L22.2549 7.4099L24.5052 5.09037L25.6857 8.08765L28.349 6.24902L28.9178 9.41629L31.8927 8.12567L31.8272 11.3421L34.9984 10.6532L34.301 13.7959L37.5467 13.731L36.2443 16.6791L39.4404 17.245L37.585 19.8844L40.6073 21.0565L38.2644 23.2843L41 25.02L38.2644 26.7535L40.605 28.9836L37.5805 30.1534L39.4358 32.7928L36.2398 33.3587L37.5421 36.3045L34.2964 36.2419L34.9916 39.3846Z",
    fill: "#213A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8873 39.2786L31.7386 38.5941L31.8018 41.786L28.8496 40.5066L28.283 43.6492L25.6377 41.824L24.464 44.7989L22.2318 42.4951L20.4938 45.1837L18.7581 42.4928L16.5236 44.7945L15.3499 41.8195L12.7069 43.647L12.1403 40.5021L9.18807 41.7815L9.25353 38.5874L6.10489 39.2719L6.79556 36.1538L3.5747 36.2164L4.86575 33.2907L1.69454 32.7271L3.53858 30.11L0.536657 28.9447L2.86146 26.7325L0.148438 25.0102L2.86371 23.2901L0.538914 21.0757L3.54084 19.9126L1.69906 17.2911L4.87027 16.7319L3.57921 13.804L6.80233 13.8688L6.11166 10.7508L9.25804 11.4375L9.1971 8.24336L12.1494 9.52279L12.7136 6.37789L15.359 8.20757L16.5326 5.23266L18.7672 7.53654L20.5051 4.8457L22.2408 7.53654L24.4753 5.2349L25.649 8.20981L28.2921 6.38237L28.8563 9.52727L31.8109 8.24783L31.7454 11.4397L34.8941 10.7575L34.2011 13.8756L37.4242 13.8129L36.1309 16.7386L39.3044 17.3001L37.4604 19.9215L40.4623 21.0847L38.1375 23.2968L40.8505 25.0192L38.1352 26.7392L40.46 28.9536L37.4581 30.1168L39.2999 32.7383L36.1264 33.2974L37.4175 36.2231L34.1944 36.1605L34.8873 39.2786Z",
    fill: "url(#paint27_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4884 8.26562C11.1373 8.26562 3.5625 15.7789 3.5625 25.0414C3.5625 34.2972 11.1373 41.7971 20.4884 41.7971C29.835 41.7971 37.4256 34.2972 37.4256 25.0414C37.4256 15.7789 29.8373 8.26562 20.4884 8.26562Z",
    fill: "url(#paint28_radial_11282_83982)",
    stroke: "#F8E579",
    strokeWidth: 0.125,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6993 18.5074L29.0651 19.637L28.5234 18.8742L30.1576 17.7447L31.6676 14.9375L32.2589 15.7718L31.1755 17.6172L33.2949 17.2302L33.8863 18.0645L30.6993 18.5074Z",
    fill: "url(#paint29_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4863 16.1407L28.4318 12.3203L30.9801 14.235L30.47 14.8993L28.6756 13.5528L27.9849 14.4497L29.513 15.5972L28.9984 16.2637L27.4703 15.1163L26.7548 16.0445L28.5469 17.3911L28.0346 18.0576L25.4863 16.1407Z",
    fill: "url(#paint30_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0801 14.9951L23.3824 10.3672L24.2965 10.6177L23.2222 14.4381L25.3483 15.0219L25.1204 15.8272L22.0801 14.9951Z",
    fill: "url(#paint31_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4086 15.1055L17.9707 10.3233L18.9164 10.2383L19.2776 14.1884L21.476 13.9938L21.5527 14.8259L18.4086 15.1055Z",
    fill: "url(#paint32_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8569 16.5176L12.8301 12.1514L15.744 10.834L16.0961 11.5945L14.0466 12.5227L14.5206 13.5472L16.2654 12.7576L16.6175 13.5181L14.8727 14.3077L15.3648 15.3679L17.4142 14.4419L17.7663 15.2024L14.8569 16.5176Z",
    fill: "url(#paint33_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7487 17.5488L11.2637 17.0254L11.4104 17.9805L12.5051 18.9356L11.8754 19.638L8.23242 16.4618L8.86215 15.7594L10.4489 17.144L9.99747 14.4912L10.7626 13.6367L11.1418 16.0927L14.48 16.7302L13.7487 17.5488Z",
    fill: "url(#paint34_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7205 27.6907L33.5672 25.275L32.9871 26.0936V27.6884H32.1113V22.3828H32.9871V24.6934L34.5693 22.3828H35.6346L34.1472 24.4921L35.7407 27.6884H34.7205V27.6907Z",
    fill: "url(#paint35_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0892 27.1553C30.7732 27.5266 30.3895 27.7369 29.8794 27.7369C29.3693 27.7369 28.9788 27.5289 28.6628 27.1553C28.2092 26.6185 28.2227 25.9564 28.2227 25.0393C28.2227 24.1223 28.2092 23.4602 28.6628 22.9234C28.9788 22.5521 29.3693 22.3418 29.8794 22.3418C30.3895 22.3418 30.7755 22.5521 31.0892 22.9234C31.5429 23.4602 31.5361 24.1223 31.5361 25.0393C31.5361 25.9564 31.5429 26.6185 31.0892 27.1553ZM30.4414 23.5497C30.315 23.3797 30.1209 23.2678 29.8817 23.2678C29.6424 23.2678 29.4393 23.3797 29.3151 23.5497C29.1458 23.7733 29.1007 24.0194 29.1007 25.0393C29.1007 26.0593 29.1436 26.3054 29.3151 26.529C29.4415 26.7013 29.6424 26.8131 29.8817 26.8131C30.1209 26.8131 30.3173 26.7013 30.4414 26.529C30.6107 26.3054 30.6626 26.0593 30.6626 25.0393C30.6604 24.0194 30.6107 23.7733 30.4414 23.5497Z",
    fill: "url(#paint36_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3509 27.1553C27.0349 27.5266 26.6512 27.7369 26.1411 27.7369C25.631 27.7369 25.2405 27.5289 24.9245 27.1553C24.4709 26.6185 24.4844 25.9564 24.4844 25.0393C24.4844 24.1223 24.4709 23.4602 24.9245 22.9234C25.2405 22.5521 25.631 22.3418 26.1411 22.3418C26.6512 22.3418 27.0349 22.5521 27.3509 22.9234C27.8046 23.4602 27.7978 24.1223 27.7978 25.0393C27.8001 25.9564 27.8069 26.6185 27.3509 27.1553ZM26.7031 23.5497C26.5767 23.3797 26.3826 23.2678 26.1434 23.2678C25.9041 23.2678 25.701 23.3797 25.5768 23.5497C25.4076 23.7733 25.3624 24.0194 25.3624 25.0393C25.3624 26.0593 25.4053 26.3054 25.5768 26.529C25.7032 26.7013 25.9041 26.8131 26.1434 26.8131C26.3826 26.8131 26.579 26.7013 26.7031 26.529C26.8724 26.3054 26.9243 26.0593 26.9243 25.0393C26.9243 24.0194 26.8724 23.7733 26.7031 23.5497Z",
    fill: "url(#paint37_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6884 27.6904H20.8105V22.3848H22.6117C23.4874 22.3848 23.9975 22.9663 23.9975 23.8745C23.9975 24.4627 23.6703 24.843 23.4446 24.9705C23.7154 25.1203 24.063 25.4536 24.063 26.1627C24.063 27.1536 23.4897 27.6904 22.6884 27.6904ZM22.544 23.3086H21.6863V24.5298H22.544C22.9164 24.5298 23.1241 24.2838 23.1241 23.9192C23.1241 23.5546 22.9141 23.3086 22.544 23.3086ZM22.6004 25.4626H21.6863V26.7666H22.6004C22.9977 26.7666 23.1873 26.4691 23.1873 26.1112C23.1873 25.7533 22.9977 25.4626 22.6004 25.4626Z",
    fill: "url(#paint38_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1797 27.6904V22.3848H19.1342V23.3086H17.0554V24.5522H18.8273V25.476H17.0554V26.7644H19.1342V27.6882H16.1797V27.6904Z",
    fill: "url(#paint39_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8729 27.7351C12.952 27.7351 12.2207 26.997 12.2207 25.8719V22.3848H13.0965V25.8339C13.0965 26.4445 13.3989 26.8091 13.8729 26.8091C14.3446 26.8091 14.6538 26.4445 14.6538 25.8339V22.3848H15.5228V25.8719C15.5228 26.997 14.7915 27.7351 13.8729 27.7351Z",
    fill: "url(#paint40_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06445 27.6904V22.3848H9.9402V26.7666H11.9761V27.6904H9.06445Z",
    fill: "url(#paint41_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11618 27.6904H5.23828V22.3848H7.03944C7.91519 22.3848 8.42529 22.9663 8.42529 23.8745C8.42529 24.4627 8.09801 24.843 7.87005 24.9705C8.1409 25.1203 8.48849 25.4536 8.48849 26.1627C8.49075 27.1536 7.91519 27.6904 7.11618 27.6904ZM6.97173 23.3086H6.11403V24.5298H6.97173C7.34414 24.5298 7.5518 24.2838 7.5518 23.9192C7.5518 23.5546 7.34189 23.3086 6.97173 23.3086ZM7.02815 25.4626H6.11403V26.7666H7.02815C7.4254 26.7666 7.615 26.4691 7.615 26.1112C7.615 25.7533 7.4254 25.4626 7.02815 25.4626Z",
    fill: "url(#paint42_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19965 32.7435C8.92654 32.6966 8.70084 32.5646 8.52478 32.3051C8.34647 32.0457 8.30133 31.7817 8.3555 31.5088C8.43224 31.1129 8.72792 30.9161 9.12743 30.6365C9.52919 30.3569 9.81584 30.1466 10.2086 30.2137C10.4817 30.2607 10.7096 30.3949 10.888 30.6544C11.0663 30.9139 11.1091 31.1733 11.055 31.4484C10.9782 31.8421 10.6848 32.0434 10.2831 32.323C9.88129 32.6049 9.59238 32.8106 9.19965 32.7435ZM10.5516 31.3098C10.5832 31.1935 10.5652 31.0592 10.4794 30.9385C10.3959 30.8154 10.2763 30.7483 10.1567 30.7371C9.99866 30.717 9.87678 30.7707 9.42987 31.0838C8.98297 31.3948 8.89043 31.4932 8.85206 31.6475C8.82046 31.7638 8.84303 31.9025 8.92429 32.0233C9.0078 32.1441 9.12517 32.2112 9.24479 32.2224C9.40279 32.2403 9.52693 32.1911 9.97383 31.8779C10.423 31.567 10.5133 31.4663 10.5516 31.3098Z",
    fill: "url(#paint43_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6132 32.5481L11.1098 33.0335L11.8592 33.8276L11.5026 34.1698L10.7532 33.378L9.92485 34.1787L9.55469 33.7873L11.5974 31.8145L12.8455 33.1364L12.4889 33.4809L11.6132 32.5481Z",
    fill: "url(#paint44_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2926 34.1284L12.8818 34.6966L13.7576 35.343L13.4664 35.7456L12.5907 35.0992L11.9158 36.0342L11.4824 35.7143L13.1504 33.4082L14.6107 34.4863L14.3218 34.8889L13.2926 34.1284Z",
    fill: "url(#paint45_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6523 37.1654L14.9479 34.6289L15.4242 34.8772L14.1263 37.4137L13.6523 37.1654Z",
    fill: "url(#paint46_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6601 38.077C15.3779 37.9718 15.1838 37.7795 15.071 37.5245C14.9084 37.1554 15.0371 36.8244 15.2041 36.3591C15.3712 35.8961 15.4863 35.5584 15.8451 35.3816C16.0934 35.2609 16.3643 35.2407 16.6464 35.3436C17.1294 35.5226 17.4025 35.9476 17.2897 36.5425L16.7796 36.3546C16.8067 36.1198 16.7367 35.9073 16.4816 35.8133C16.344 35.7619 16.213 35.7731 16.1092 35.8335C15.9693 35.9118 15.8948 36.0281 15.7075 36.5448C15.5201 37.0615 15.5043 37.2001 15.5607 37.35C15.6014 37.4641 15.6962 37.558 15.8339 37.6095C16.0889 37.7034 16.2785 37.5849 16.4072 37.388L16.9195 37.5759C16.6216 38.106 16.1386 38.2514 15.6601 38.077Z",
    fill: "url(#paint47_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2441 38.5577L17.8242 35.7617L18.3479 35.8736L17.7678 38.6695L17.2441 38.5577Z",
    fill: "url(#paint48_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9533 38.9321L19.8314 38.4132L18.8586 38.3349L18.6532 38.8247L18.0957 38.78L19.319 36.0176L19.7389 36.0511L20.5108 38.9768L19.9533 38.9321ZM19.4748 36.872L19.0459 37.8786L19.7276 37.9345L19.4748 36.872Z",
    fill: "url(#paint49_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8676 38.9298L20.7051 36.0801L21.24 36.0488L21.3754 38.4019L22.6191 38.3303L22.6484 38.8269L20.8676 38.9298Z",
    fill: "url(#paint50_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3989 37.6842C25.2725 37.9817 25.0558 38.1561 24.7782 38.2568C24.4961 38.3597 24.2252 38.3396 23.9769 38.2165C23.618 38.0398 23.5074 37.7021 23.3404 37.2368C23.1734 36.7738 23.047 36.4405 23.2118 36.0715C23.3246 35.8165 23.5142 35.6286 23.8031 35.5235C24.4013 35.3043 24.8527 35.5995 25.0829 36.029L24.575 36.2146C24.4261 35.9842 24.2275 35.8992 23.9701 35.9932C23.8325 36.0446 23.7399 36.1408 23.6993 36.2549C23.6406 36.4048 23.6609 36.5367 23.846 37.0557C24.0311 37.5723 24.1011 37.6909 24.241 37.7692C24.3448 37.8296 24.4757 37.8408 24.6134 37.7893C24.7646 37.7334 24.8685 37.6327 24.9181 37.5075C24.9655 37.3777 24.9565 37.2458 24.9068 37.1071L24.8707 37.0042L24.3945 37.1787L24.2387 36.7403L25.2138 36.3824L25.3537 36.7738C25.4914 37.163 25.5117 37.4225 25.3989 37.6842Z",
    fill: "url(#paint51_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2999 37.1904C26.8079 37.4677 26.2256 37.3403 25.9344 36.8124L25.0293 35.1728L25.4965 34.9089L26.3926 36.5305C26.5528 36.8168 26.8079 36.8996 27.0607 36.7565C27.3135 36.6133 27.3834 36.3494 27.2254 36.0631L26.3294 34.4414L26.7943 34.1797L27.6972 35.8192C27.9928 36.3449 27.7942 36.913 27.2999 37.1904Z",
    fill: "url(#paint52_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9025 36.1683L27.1172 33.9516L27.5347 33.6094L29.3178 35.8238L28.9025 36.1683Z",
    fill: "url(#paint53_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8986 33.9996C30.9008 34.2613 30.7767 34.5051 30.5736 34.7087L29.8694 35.4132L27.8809 33.3823L28.5851 32.6777C28.7882 32.4741 29.0297 32.3511 29.2915 32.3556C29.7339 32.3645 29.9867 32.6665 30.2847 32.9707C30.5826 33.2771 30.8941 33.5523 30.8986 33.9996ZM29.3028 32.9081C29.1561 32.8924 29.0275 32.9349 28.8965 33.0669L28.6076 33.3554L29.9032 34.6796L30.1899 34.391C30.323 34.2591 30.3682 34.1293 30.3524 33.9795C30.3343 33.8162 30.2034 33.6596 29.901 33.3509C29.6008 33.0445 29.4631 32.9282 29.3028 32.9081Z",
    fill: "url(#paint54_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6722 33.4074L29.3203 31.826L30.3225 30.3027L30.731 30.5779L30.0268 31.6493L30.5775 32.0206L31.1779 31.108L31.5864 31.3831L30.986 32.2957L31.5571 32.6804L32.2636 31.609L32.6743 31.8841L31.6722 33.4074Z",
    fill: "url(#paint55_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4517 16.9507C23.79 16.9507 26.6497 18.9482 27.9001 21.8H28.3989C27.1214 18.6887 24.0495 16.4922 20.4495 16.4922C16.8494 16.4922 13.7775 18.6887 12.5 21.8H12.9988C14.2538 18.9482 17.1135 16.9507 20.4517 16.9507Z",
    fill: "url(#paint56_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.45 33.0562C17.1366 33.0562 14.2927 31.0879 13.0287 28.2695H12.5254C13.8187 31.3473 16.8748 33.5148 20.45 33.5148C24.0253 33.5148 27.0813 31.3473 28.3747 28.2695H27.8736C26.6074 31.0879 23.7634 33.0562 20.45 33.0562Z",
    fill: "url(#paint57_linear_11282_83982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.127 54.2373C33.127 54.5818 32.8538 54.8547 32.4972 54.8547C32.1451 54.8547 31.8652 54.584 31.8652 54.2373C31.8652 53.8996 32.1451 53.6289 32.4972 53.6289C32.8538 53.6267 33.127 53.8996 33.127 54.2373ZM32.0232 54.2373C32.0232 54.508 32.2264 54.7227 32.5017 54.7227C32.7703 54.7227 32.969 54.508 32.969 54.2396C32.969 53.9689 32.7703 53.7497 32.4972 53.7497C32.2241 53.7497 32.0232 53.9689 32.0232 54.2373ZM32.4002 54.5549H32.258V53.9465C32.3144 53.9354 32.3934 53.9286 32.495 53.9286C32.6101 53.9286 32.6643 53.9465 32.7094 53.9734C32.7432 54.0002 32.7703 54.0472 32.7703 54.1076C32.7703 54.1747 32.7184 54.2261 32.6439 54.2485V54.2552C32.7026 54.2776 32.7387 54.3223 32.7568 54.4028C32.7749 54.4968 32.7861 54.5326 32.8019 54.5549H32.6485C32.6304 54.5326 32.6191 54.4767 32.5988 54.4073C32.5875 54.3402 32.5491 54.3111 32.4724 54.3111H32.4047V54.5549H32.4002ZM32.4047 54.2105H32.4724C32.5514 54.2105 32.6146 54.1859 32.6146 54.121C32.6146 54.0651 32.574 54.0271 32.4837 54.0271C32.4453 54.0271 32.4205 54.0315 32.4047 54.0338V54.2105Z",
    fill: "#213A78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -14.5883) scale(24.0021 31.2906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9432,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.659 29.0995) scale(22.5418 22.3389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00495866,
    stopColor: "#DBE0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#18659C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    stopColor: "#094B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11282_83982",
    x1: 19.4881,
    y1: 27.2835,
    x2: 39.9612,
    y2: 55.7787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2353,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4133,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5283,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5694,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6796,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7733,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11282_83982",
    x1: 5.90715,
    y1: 30.052,
    x2: 24.0151,
    y2: 51.9237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -11.0897) scale(24.0023 23.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9432,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11282_83982",
    x1: 20.465,
    y1: -9.19597,
    x2: 25.1994,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11282_83982",
    x1: 4.23326,
    y1: -3.77167,
    x2: 8.96772,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -11.0897) scale(24.0023 23.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9432,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11282_83982",
    x1: 20.465,
    y1: -9.19597,
    x2: 25.1994,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11282_83982",
    x1: 4.23326,
    y1: -3.77167,
    x2: 8.96772,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -11.0897) scale(24.0023 23.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9432,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11282_83982",
    x1: 20.465,
    y1: -9.19597,
    x2: 25.1994,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11282_83982",
    x1: 4.23326,
    y1: -3.77167,
    x2: 8.96772,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -11.0897) scale(24.0023 23.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9432,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11282_83982",
    x1: 20.4669,
    y1: -9.19597,
    x2: 25.2013,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_11282_83982",
    x1: 4.23327,
    y1: -3.77167,
    x2: 8.96774,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -11.0897) scale(24.0023 23.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9432,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_11282_83982",
    x1: 20.4669,
    y1: -9.19597,
    x2: 25.2013,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_11282_83982",
    x1: 4.23327,
    y1: -3.77167,
    x2: 8.96774,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -11.0897) scale(24.0023 23.7863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9432,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_11282_83982",
    x1: 20.4669,
    y1: -9.19597,
    x2: 25.2013,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_11282_83982",
    x1: 4.23327,
    y1: -3.77167,
    x2: 8.96774,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1922 -13.8841) scale(28.7169 28.4584)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5124,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8344,
    stopColor: "#233971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_11282_83982",
    x1: 20.4669,
    y1: -9.19597,
    x2: 25.2013,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_11282_83982",
    x1: 4.23327,
    y1: -3.77167,
    x2: 8.96774,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_11282_83982",
    x1: 20.4669,
    y1: -9.19597,
    x2: 25.2013,
    y2: 4.97151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_11282_83982",
    x1: 4.23327,
    y1: -3.77167,
    x2: 8.96774,
    y2: 10.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#B37418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_11282_83982",
    x1: 7.37658,
    y1: -0.7566,
    x2: 26.9594,
    y2: 38.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4657,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E39B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6528,
    stopColor: "#D8970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8919,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9376,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE3E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_11282_83982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.30521 4.20555) scale(32.3028 32.012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#497FC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "#457BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C6EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6128,
    stopColor: "#3665AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#335DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    stopColor: "#2C4C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#21345E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_11282_83982",
    x1: 19.083,
    y1: 0.365533,
    x2: 41.1002,
    y2: 33.8449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_11282_83982",
    x1: 18.4199,
    y1: 0.934615,
    x2: 40.836,
    y2: 34.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_11282_83982",
    x1: 15.3745,
    y1: 3.0388,
    x2: 39.8836,
    y2: 34.2419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_11282_83982",
    x1: 12.447,
    y1: 4.8302,
    x2: 37.0864,
    y2: 36.4843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_11282_83982",
    x1: 9.72955,
    y1: 6.93259,
    x2: 35.0258,
    y2: 38.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_11282_83982",
    x1: 5.75135,
    y1: 10.4211,
    x2: 32.4298,
    y2: 40.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_11282_83982",
    x1: 18.4867,
    y1: 3.67201,
    x2: 39.5444,
    y2: 33.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_11282_83982",
    x1: 15.7266,
    y1: 5.38859,
    x2: 37.2103,
    y2: 35.7675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_11282_83982",
    x1: 13.4319,
    y1: 7.3931,
    x2: 34.9165,
    y2: 37.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_11282_83982",
    x1: 11.0586,
    y1: 9.72879,
    x2: 32.3057,
    y2: 39.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_11282_83982",
    x1: 8.34168,
    y1: 12.1013,
    x2: 29.5664,
    y2: 42.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_11282_83982",
    x1: 6.26036,
    y1: 13.9102,
    x2: 27.5355,
    y2: 43.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_11282_83982",
    x1: 3.24992,
    y1: 16.3552,
    x2: 24.4877,
    y2: 46.3865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_11282_83982",
    x1: 1.43606,
    y1: 17.9915,
    x2: 22.6833,
    y2: 48.0361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_11282_83982",
    x1: -1.15767,
    y1: 11.2206,
    x2: 18.7656,
    y2: 49.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_11282_83982",
    x1: -0.947984,
    y1: 11.217,
    x2: 19.2957,
    y2: 48.9602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_11282_83982",
    x1: -0.846093,
    y1: 11.5491,
    x2: 20.5864,
    y2: 48.5487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_11282_83982",
    x1: -1.19685,
    y1: 11.8222,
    x2: 21.9584,
    y2: 48.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_11282_83982",
    x1: -0.571742,
    y1: 11.7273,
    x2: 22.8903,
    y2: 47.4037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_11282_83982",
    x1: -0.42703,
    y1: 11.6174,
    x2: 24.1321,
    y2: 46.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_11282_83982",
    x1: 0.0270362,
    y1: 11.4195,
    x2: 24.8123,
    y2: 46.1496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_11282_83982",
    x1: 1.76217,
    y1: 10.1944,
    x2: 26.0387,
    y2: 45.1693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_11282_83982",
    x1: 1.79483,
    y1: 10.1048,
    x2: 28.8961,
    y2: 42.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_11282_83982",
    x1: 4.00113,
    y1: 8.53144,
    x2: 30.8058,
    y2: 41.4559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_11282_83982",
    x1: 3.89421,
    y1: 8.70103,
    x2: 32.5193,
    y2: 40.0835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_11282_83982",
    x1: 5.60913,
    y1: 6.97461,
    x2: 33.7921,
    y2: 38.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_11282_83982",
    x1: 5.94513,
    y1: 6.58542,
    x2: 35.7018,
    y2: 37.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    stopColor: "#F8ECA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2933,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_11282_83982",
    x1: 10.3611,
    y1: 9.78578,
    x2: 32.4596,
    y2: 35.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1656,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_11282_83982",
    x1: 6.8071,
    y1: 12.8,
    x2: 28.9064,
    y2: 38.8427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1656,
    stopColor: "#F5D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBF3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    stopColor: "#EEC450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#E6B741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6044,
    stopColor: "#F4D96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6489,
    stopColor: "#F8E579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#E4AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#E6B300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9511,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11282_83982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKbb);
export default __webpack_public_path__ + "static/media/logo-kbb.d7a68d70bec310a3b69d185480d034e6.svg";
export { ForwardRef as ReactComponent };